import React from "react";
import { Accordion } from "react-bootstrap";

const AboutTab = () => {
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="tab-content" id="collapseTwo">
          <Accordion.Body className="height_set">
            <div className="about_content">
              <div className="safrititles pt-3 pb-0">
                <h5>About Satpura Tiger Reserve</h5>
              </div>
              <p></p>
              <p>
                Satpura National Park, nestled in the heart of central India in
                the state of Madhya Pradesh, is a haven for nature enthusiasts
                and wildlife lovers seeking an off-the-beaten-path adventure.
                Spanning over 524 square kilometers, this biodiverse sanctuary
                remains relatively unexplored compared to its more famous
                counterparts, offering visitors a chance to immerse themselves
                in the untamed wilderness of the Satpura Range.
                <br />
                <br />
                What sets Satpura apart is its diverse terrain, comprising deep
                gorges, rugged hills, dense forests, and meandering rivers. This
                varied landscape creates a mosaic of habitats, providing shelter
                to a rich array of flora and fauna. From towering teak trees to
                delicate orchids, Satpura's flora showcases the region's
                botanical diversity.
                <br />
                <br />
                But it's the park's wildlife that truly steals the show. Satpura
                is home to a remarkable diversity of mammals, including elusive
                big cats like leopards and tigers, Indian gaur (bison), sloth
                bears, wild dogs, and sambar deer. Birdwatchers will delight in
                the opportunity to spot over 250 avian species, including the
                Malabar pied hornbill, Indian pitta, and paradise flycatcher,
                among others.
                <br />
                <br />
                Exploring Satpura is an adventure like no other. Visitors can
                embark on thrilling jeep safaris, guided walks, boat rides, and
                even elephant safaris to traverse the park's rugged terrain and
                encounter its inhabitants up close. The park's relatively low
                tourist numbers ensure a more intimate wildlife experience,
                allowing for peaceful moments of solitude amidst nature's
                bounty.
                <br />
                <br />
                Beyond its natural splendor, Satpura holds cultural and
                historical significance, with ancient cave paintings dating back
                thousands of years found in the surrounding hills. The park's
                serene ambiance and remote location offer a retreat from the
                hustle and bustle of modern life, allowing visitors to reconnect
                with nature and themselves.
                <br />
                <br />
                In conclusion, Satpura National Park is a hidden gem waiting to
                be discovered by intrepid travelers and nature enthusiasts. Its
                pristine wilderness, diverse wildlife, and tranquil ambiance
                make it a sanctuary for both the body and soul, offering a
                glimpse into the unspoiled beauty of the natural world.
              </p>
              <p></p>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default AboutTab;
